import React from 'react';
import InviteModal from '../../components/invite-modal2';
import _ from 'lodash';

const TestContainer = () => (
  <div>
    <h1>this is not a test!</h1>

    <InviteModal
      thumbnail="https://scontent-lht6-1.cdninstagram.com/vp/f8da84290e055d6da7ad8dfa48088c82/5E6F89EE/t51.2885-19/s320x320/67120347_431260040811500_4819299055274295296_n.jpg?_nc_ht=scontent-lht6-1.cdninstagram.com"
      closeHandler={_.noop}
      sendHandler={_.noop}
      email="info+cass@dyzio.co"
      name="Cass DiMicco"
      inviteSentOK={false}
    />

  </div>
);

export default TestContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/test-container/index.js
 **/